/* ------------------------------------------------------------------
   Mr Football - FREE MYSTERY GEAR WITH YOUR BOOTS (re-run from 24 Oct 2026).
   Markup in snippets/mf-boot-mystery.liquid.
   Loaded once, sitewide, from layout/theme.liquid.

   THREE JOBS
     1. keep the gift line in the cart honest, on EVERY page
     2. fold the gift into the shopper's own add-to-cart call, so the
        drawer opens already showing it
     3. dress the gift's cart line - the product has no photo, so the
        theme drew a grey placeholder shirt. A green gift tile replaces it.

   WHY A RECONCILER AND NOT AN ADD-TO-CART HOOK
   Boots get added from the product page, quickview and the collection
   grid. The cart is the source of truth: read /cart.js, count the boots,
   make the gift line match. Idempotent, self-healing. It also REMOVES
   the gift when there are no boots - /products/mystery-gear-boots is a
   live $0.00 page, and without this anyone could take it on its own.

   WHY THE WRAPPER MATCHES VARIANT IDS
   The PDP snippet is reused by quickview/featured sections, so the
   block's presence does not prove the boot is what is being added. Each
   block lists its own variant ids in data-mf-mg-variants.

   TIME COMES FROM SHOPIFY (the Date header on /cart.js), not the
   shopper's clock. PROMO_START / PROMO_END are repeated in the Liquid
   snippet - change both together. PROMO_END = 0 means no end date.

   NOTHING HERE APPLIES A DISCOUNT. The gift variant is $0.00 with a
   $12.99 compare-at - free by construction. Do NOT turn this into a
   Buy-X-Get-Y: with THE HAT-TRICK active (combines with nothing), the
   BXGY loses and the shopper is charged $12.99 for a "free" gift.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfMysteryGear) { return; }
  window.__mfMysteryGear = true;

  var GIFT_VARIANT = 53494300934325;
  var GIFT_HANDLE  = 'mystery-gear-boots';

  /* = "Men's Boots" smart collection rule (TITLE CONTAINS cleats OR turf);
     every Kids' Boots product matches too. */
  var BOOT_RE = /cleats|turf/i;

  var PROMO_START = 1792789200; /* 2026-10-24 00:00:00 +03:00 */
  var PROMO_END   = 0;          /* 0 = no end date */

  var serverNow = null;
  var busy = false;
  var reloadedOnce = false;

  function nowSeconds() {
    return serverNow === null ? Math.floor(Date.now() / 1000) : serverNow;
  }

  function live() {
    var s = nowSeconds();
    return s >= PROMO_START && (PROMO_END === 0 || s <= PROMO_END);
  }

  function takeServerTime(res) {
    try {
      var d = res.headers && res.headers.get ? res.headers.get('Date') : null;
      if (!d) { return; }
      var t = Date.parse(d);
      if (!isNaN(t)) { serverNow = Math.floor(t / 1000); }
    } catch (e) {}
  }

  /* ---------------------------------------------------------------
     CART LINE LOOK
     Pure CSS keyed on the gift's product link, so it works in the
     drawer, on /cart, and after any re-render, with no DOM watching.
  --------------------------------------------------------------- */
  function dressCartLine() {
    if (document.getElementById('mf-mg-cart-css')) { return; }
    var gift = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' fill='none' stroke='white' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='7' y='19' width='34' height='23' rx='3'/%3E%3Cpath d='M5 13h38v7H5z'/%3E%3Cpath d='M24 13v29'/%3E%3Cpath d='M24 13c-2-5-5-8-8.5-8a3.8 3.8 0 0 0 0 7.6H24'/%3E%3Cpath d='M24 13c2-5 5-8 8.5-8a3.8 3.8 0 0 1 0 7.6H24'/%3E%3C/svg%3E";
    var sel = 'a[href*="/products/' + GIFT_HANDLE + '"]';
    var css =
      sel + ' .placeholder-svg{display:none!important}' +
      sel + ':has(.placeholder-svg){display:block;aspect-ratio:1/1;width:100%;border-radius:8px;' +
        'background:#349909 url("' + gift + '") center/48% no-repeat}';
    var st = document.createElement('style');
    st.id = 'mf-mg-cart-css';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  /* ---------------------------------------------------------------
     THE RECONCILER
  --------------------------------------------------------------- */
  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function reconcile() {
    if (busy) { return Promise.resolve(false); }
    busy = true;

    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { takeServerTime(res); return res.json(); })
      .then(function (cart) {
        var boots = 0;
        var giftKeys = [];
        var giftQty = 0;

        (cart.items || []).forEach(function (item) {
          if (item.handle === GIFT_HANDLE) {
            giftKeys.push(item.key);
            giftQty += item.quantity;
            return;
          }
          if (BOOT_RE.test(item.product_title || item.title || '')) {
            boots += item.quantity;
          }
        });

        /* One pack per pair. For one per order: Math.min(boots, 1). */
        var want = live() ? boots : 0;

        var extras = giftKeys.slice(1);
        var jobs = extras.map(function (k) { return post('/cart/change.js', { id: k, quantity: 0 }); });

        if (want !== giftQty || extras.length) {
          if (want === 0) {
            if (giftKeys.length) { jobs.push(post('/cart/change.js', { id: giftKeys[0], quantity: 0 })); }
          } else if (!giftKeys.length) {
            jobs.push(post('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: want }] }));
          } else {
            jobs.push(post('/cart/change.js', { id: giftKeys[0], quantity: want }));
          }
        }

        if (!jobs.length) { return false; }
        return Promise.all(jobs).then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (changed) { busy = false; return changed; });
  }

  function repaint(changed) {
    if (!changed) { return; }
    if (document.body && document.body.classList.contains('template-cart')) {
      if (reloadedOnce) { return; }
      reloadedOnce = true;
      window.location.reload();
      return;
    }
    ['cart:refresh', 'cart:updated', 'ajaxCart:refresh'].forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
    });
  }

  /* ---------------------------------------------------------------
     RIDING ALONG WITH THE SHOPPER'S OWN ADD-TO-CART
     Both fetch and XHR are wrapped (the theme uses both). Every failure
     path falls through to the original call untouched.
  --------------------------------------------------------------- */
  function isAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  function ours(id) {
    if (!id) { return false; }
    var needle = ',' + String(id).trim() + ',';
    var nodes = document.querySelectorAll('[data-mf-mg-variants]');
    for (var i = 0; i < nodes.length; i++) {
      var list = ',' + (nodes[i].getAttribute('data-mf-mg-variants') || '') + ',';
      if (list.indexOf(needle) !== -1) { return true; }
    }
    return false;
  }

  function withGift(body) {
    try {
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var obj = JSON.parse(body);
          if (obj.items && obj.items.length) {
            var n = 0;
            obj.items.forEach(function (it) { if (ours(it.id)) { n += (it.quantity || 1); } });
            if (!n) { return null; }
            obj.items.push({ id: GIFT_VARIANT, quantity: n });
            return JSON.stringify(obj);
          }
          if (obj.id && ours(obj.id)) {
            var q0 = obj.quantity || 1;
            return JSON.stringify({ items: [
              { id: obj.id, quantity: q0, properties: obj.properties },
              { id: GIFT_VARIANT, quantity: q0 }
            ] });
          }
          return null;
        }

        var p = new URLSearchParams(body);
        var id = p.get('id');
        if (!ours(id)) { return null; }
        var q = parseInt(p.get('quantity'), 10) || 1;
        var out = new URLSearchParams();
        out.append('items[0][id]', id);
        out.append('items[0][quantity]', String(q));
        out.append('items[1][id]', String(GIFT_VARIANT));
        out.append('items[1][quantity]', String(q));
        p.forEach(function (v, k) {
          if (k.indexOf('properties') === 0) { out.append('items[0][' + k + ']', v); }
        });
        return out.toString();
      }

      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var fid = body.get('id');
        if (!ours(fid)) { return null; }
        var fq = parseInt(body.get('quantity'), 10) || 1;
        var fd = new FormData();
        fd.append('items[0][id]', fid);
        fd.append('items[0][quantity]', String(fq));
        fd.append('items[1][id]', String(GIFT_VARIANT));
        fd.append('items[1][quantity]', String(fq));
        body.forEach(function (v, k) {
          if (k.indexOf('properties') === 0) { fd.append('items[0][' + k + ']', v); }
        });
        return fd;
      }
    } catch (e) {}
    return null;
  }

  function wrapFetch() {
    if (typeof window.fetch !== 'function') { return; }
    var orig = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (live() && isAddUrl(url) && init && init.body) {
          var swapped = withGift(init.body);
          if (swapped !== null) {
            init = Object.assign({}, init, { body: swapped });
          }
        }
      } catch (e) {}
      return orig.apply(this, [input, init]);
    };
  }

  function wrapXHR() {
    var XHR = window.XMLHttpRequest;
    if (!XHR || !XHR.prototype) { return; }
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      try { this.__mfAdd = isAddUrl(url); } catch (e) {}
      return open.apply(this, arguments);
    };

    XHR.prototype.send = function (body) {
      try {
        if (this.__mfAdd && live() && body) {
          var swapped = withGift(body);
          if (swapped !== null) { body = swapped; }
        }
      } catch (e) {}
      return send.call(this, body);
    };
  }

  function init() {
    dressCartLine();
    wrapFetch();
    wrapXHR();

    var go = function () { reconcile().then(repaint); };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(go, { timeout: 2500 });
    } else {
      setTimeout(go, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
